<template>
  <section class="table-sampler-memory-heat">
    <d-form-row>
      <d-col cols="3">
        <label>Instrumento</label>
        <input
          type="text"
          class="form-control"
          placeholder="Instrumento"
          v-model="model.instrument"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>N.º de série</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º de série"
          v-model="model.instrument_serie"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Certificado de aferição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Certificado de aferição"
          v-model="model.instrument_certificate"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Validade</label>
        <input
          type="text"
          class="form-control"
          placeholder="Validade"
          v-model="model.instrument_validity"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row>
      <d-col cols="3">
        <label>N. Medição</label>
        <input
          type="text"
          class="form-control"
          placeholder="N. Medição"
          v-model="model.medition"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Agente</label>
        <input
          type="text"
          class="form-control"
          placeholder="Agente"
          v-model="model.agent"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Método</label>
        <select
          type="text"
          class="form-control"
          v-model="model.method"
          required
        >
          <option value="NHO 06">NHO 06</option>
        </select>
      </d-col>
      <d-col cols="3">
        <label>Limite de exposição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Limite de exposição"
          v-model="model.exposition_limit"
          required
        />
      </d-col>
    </d-form-row>
    <ul class="tasks">
      <li v-for="(row, index) in model.tasks" :key="index" class="form-row m-0">
        <d-col cols>
          <d-form-row>
            <d-col cols="12">
              <label>Tarefa</label>
              <input
                type="text"
                class="form-control"
                placeholder="Tarefa"
                v-model="row.task"
                required
              />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col cols="2">
              <label>URA %</label>
              <input
                type="text"
                class="form-control"
                placeholder="URA"
                v-model="row.ura"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Início</label>
              <input
                type="time"
                class="form-control"
                placeholder="Início"
                v-model="row.initial"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Término</label>
              <input
                type="time"
                class="form-control"
                placeholder="Término"
                v-model="row.final"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Duração</label>
              <input
                type="time"
                class="form-control"
                placeholder="Duração"
                v-model="row.duration"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Metabolismo</label>
              <input
                type="text"
                class="form-control"
                placeholder="Metabolismo"
                v-model="row.metabolism"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Tipo de atividade</label>
              <input
                type="text"
                class="form-control"
                placeholder="Tipo de atividade"
                v-model="row.activity_type"
                required
              />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col cols="2">
              <label>V.Ar</label>
              <input
                type="text"
                class="form-control"
                placeholder="V.Ar"
                v-model="row.var"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Tbs <small>(C˚)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Tbs"
                v-model="row.tbs"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Tbn <small>(C˚)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Tbn"
                v-model="row.tbn"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Tg <small>(C˚)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Tg"
                v-model="row.tg"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>IBUTG</label>
              <input
                type="text"
                class="form-control"
                placeholder="IBUTG"
                v-model="row.ibutg"
                required
              />
            </d-col>
          </d-form-row>
        </d-col>
        <d-col cols="auto" class="d-flex align-items-end justify-content-end">
          <i class="cursor-pointer fas fa-plus text-success" @click="addTaskRow()" v-if="index + 1 === model.tasks.length"></i>
          <i class="cursor-pointer fas ml-2 fa-minus text-danger" @click="removeTaskRow(index)" ></i>
        </d-col>
      </li>
    </ul>

    <epi-list :list.sync="model.epis"></epi-list>

    <d-form-row>
      <d-col cols="12">
        <label>Observações</label>
        <textarea
          type="text"
          class="form-control"
          placeholder="Observações"
          v-model="model.observation"
          required
        ></textarea>
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { TASK_HEAT, HEAT_MEMORY, _LOAD_MODEL_ } from '../../SampleModel';
import EpiList from '../EPIList.vue';

export default {
  name: 'Sample-Memory-Heat',
  props: {
    memory: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(HEAT_MEMORY),
    };
  },
  components: {
    EpiList,
  },
  methods: {
    setModel() {
      if (this.memory) {
        this.model = { ...HEAT_MEMORY, ...this.memory };
      }
    },
    addTaskRow() {
      this.model.tasks.push({ ...TASK_HEAT });
    },
    removeTaskRow(index) {
      this.model.tasks.splice(index, 1);
      if (this.model.tasks.length === 0) {
        this.addTaskRow();
      }
    },
  },
  mounted() {
    this.setModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:memory', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-sampler-memory-heat {
  label {
    margin-bottom: 0;
  }
  .tasks {
    padding: 0;
    list-style: none;
    width: 100%;
    border: 1px solid #bbb;
    border-radius: 5px;
    margin: 10px 0 0;
    li {
      display: flex;
      padding: 10px;
      align-items: center;
      width: 100%;
      margin-bottom: 30px;
      &:nth-child(even) {
        background: #eee;
      }
    }
  }
  .cursor-pointer {
    cursor: pointer;
  }
}
</style>
